import Modal from '../Modal';
/**
 * A generic confirmation modal.
 *
 * Props
 *  - visible: boolean
 *  - title: string | ReactNode
 *  - onConfirm: () => void
 *  - onCancel: () => void
 *  - confirmText?: string (default: 'SALVA')
 *  - cancelText?: string (default: 'INDIETRO')
 *  - confirmClassName?: string (default: 'button button--primary')
 *  - cancelClassName?: string (default: 'button button--secondary')
 *  - children?: ReactNode  // optional body/content of the modal
 */
const ConfirmModal = ({
  visible,
  title,
  onConfirm,
  onCancel,
  confirmText = 'SALVA',
  cancelText = 'INDIETRO',
  confirmClassName = 'button button--primary',
  cancelClassName = 'button button--secondary',
  confirmDisable = false,
  children
}) => {
  return (
    <Modal visible={visible} title={title}>
      {children}

      <div className="button-container">
        <button className={cancelClassName} onClick={onCancel}>
          {cancelText}
        </button>
        <button 
          className={confirmClassName}
          onClick={onConfirm}
          disabled={confirmDisable}
          aria-disabled={confirmDisable}
        >
          {confirmText}
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmModal;

